<template>
  <div
    v-show="visible"
    ref="wrapper"
    :class="['edit', isFocus ? 'z-10' : '']"
    :style="style"
    @click="$emit('clickFeedback')"
  >
    <div ref="title" class="title">
      <div class="flex items-center justify-center">
        <img class="inline-block drag-none w-5" src="../assets/feedback.png" alt="笔记" />
        <span class="title-text">反馈</span>
      </div>
    </div>
    <div class="flex-1 flex flex-col px-6 pb-4 pt-2">
      <div v-for="(feedback, index) in feedbackList" :key="index" class="mb-4">
        <label class="flex items-center justify-between">
          <span class="label-text">{{ feedback.type }}</span>
          <input v-model="feedback.check" type="checkbox" class="checkbox" />
        </label>
      </div>
      <label class="flex items-center justify-between">
        <span class="label-text">其他</span>
        <input v-model="otherChecked" type="checkbox" class="checkbox" />
      </label>
    </div>
    <transition name="other" :duration="{ enter: 500, leave: 300 }">
      <div v-if="otherChecked" class="textarea-wrapper">
        <textarea
          v-model="otherValue"
          class="textarea"
          rows="5"
          maxlength="300"
          placeholder="请输入您的反馈"
        ></textarea>
      </div>
    </transition>
    <div class="action-wrapper">
      <!-- PC -->
      <div class="flex justify-end mx-6 mb-2">
        <button class="button cancel-button" @click="handleCancel">取 消</button>
        <button class="button confirm-button" @click="handleSubmit">确 认</button>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Content } from '@forchange/storytime';
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { SystemData } from '..';
import Position from '../mixins/position';
import CREATE_FEEDBACK from '../graphql/createFeedback';

const feedbackList = [
  {
    type: '错别字',
    check: false
  },
  {
    type: '内容缺失',
    check: false
  },
  {
    type: '章节错乱',
    check: false
  },
  {
    type: '内容违规',
    check: false
  }
];
@Component
export default class FeedbackEdit extends Mixins(Position) {
  @Prop({ type: Boolean }) visible: Boolean;
  @Prop({ type: Object }) content: Content & {
    messages: Array<string>;
  };
  @Prop({ type: String }) selectValue: String;
  @Prop({ type: Number }) changeTime: number;
  @Prop({ type: Boolean }) isFocus: boolean;
  @Prop({ type: Object }) system: SystemData;

  feedbackList: Array<{ type: string; check: boolean }> = [
    {
      type: '错别字',
      check: false
    },
    {
      type: '内容缺失',
      check: false
    },
    {
      type: '章节错乱',
      check: false
    },
    {
      type: '内容违规',
      check: false
    }
  ];

  otherChecked = false;
  otherValue = '';

  get style() {
    return {
      top: (this.position.top || 0) + 'px',
      left: (this.position.left || 0) + 'px'
    };
  }

  @Watch('visible')
  visibleChange() {
    this.initPosition();
  }

  mounted() {
    this.initPosition();
    this.bindEvents();
  }

  onPointerDown(e: MouseEvent | TouchEvent) {
    this.$emit('clickFeedback');
    const page = this.getPagePosition(e);
    if (!page) return;
    this.moving = true;
    this.startPoint = {
      pageX: page.x,
      pageY: page.y
    };
  }

  close() {
    this.$emit('update:visible', false);
  }

  handleCancel() {
    this.$emit('update:visible', false);
    this.feedbackList = this.feedbackList.map((item) => {
      item.check = false;
      return item;
    });
    this.otherChecked = false;
    this.otherValue = '';
  }

  async handleSubmit() {
    // 提交数据
    if (!this.checkValue()) return;
    if (!this.$getClemanClient().token)
      return this.$Message.warn({
        time: 3000,
        content: '请先登录后再进行反馈哦'
      });
    const submitData = this.filterData();
    // 请求
    try {
      await this.$getClemanClient().apollo.mutate({
        mutation: CREATE_FEEDBACK,
        variables: {
          create: {
            courseVersion: this.system.version,
            courseId: this.system.courseId,
            resourceId: this.content.$id,
            resourceType: this.content.$kind,
            selectValue: this.content.messages[this.system.utteranceIndex],
            feedbacks: submitData.selects,
            index: this.system.utteranceIndex,
            other: submitData.other
          }
        }
      });
      this.$Message.success({
        time: 1500,
        content: '反馈成功'
      });
    } catch (error) {
      this.$Message.error({
        time: 1500,
        content: '请求貌似出了些问题，可以尝试重新填写'
      });
      console.log(error);
    }

    // 清理数据
    this.handleCancel();
  }
  filterData() {
    const data = {
      selects: this.feedbackList.filter((item) => item.check).map((item) => item.type),
      other: ''
    };

    if (this.otherChecked) {
      data.other = this.otherValue;
    }

    return data;
  }
  checkValue() {
    if (this.otherChecked && this.otherValue.length) return true;
    if (this.otherChecked && !this.otherValue.length) {
      this.$Message.info({
        time: 1500,
        content: '选择了其他，写一点原因，让我们一起更好的成长'
      });
    }
    if (this.feedbackList.some((item) => item.check)) {
      return true;
    } else {
      this.$Message.warn({
        time: 1500,
        content: '至少选择一个反馈哦'
      });
    }
  }
}
</script>
<style scoped>
/* common */
.edit {
  @apply flex resize-x flex-col fixed min-w-80 w-80 max-w-full max-h-full rounded-md overflow-hidden bg-white;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
}
.drag-none {
  -webkit-user-drag: none;
}

/* title */
.title {
  @apply flex justify-between items-center pl-6 pr-6 py-2 relative cursor-move select-none;
  flex: 0 0 2rem;
}
.title-text {
  @apply font-medium text-lg ml-3;
  color: #3f3356;
}

/* ckeckbox */
.label-text {
  color: rgba(63, 51, 86, 0.8);
  font-size: 14px;
}
.checkbox {
  @apply text-motif-500;
  --tw-ring-offset-width: none !important;
  border-radius: 50%;
}

/* 其他 拓展文本域 */
.textarea {
  @apply ring-0 border-none resize-none w-full;
  background: #f6f7fc;
  border-radius: 5px;
}
.textarea-wrapper {
  @apply w-full h-full px-6;
  transition: all 0.3s;
}
.other-enter,
.other-leave-to {
  opacity: 0;
}

/* 按钮部分 */
.action-wrapper {
  flex: 0 0 2rem;
  @apply my-2;
}
.button {
  @apply py-1 px-2 tracking-widest;
  width: 78px;
  height: 34px;
  font-size: 14px;
  border-radius: 6px;
}
.cancel-button {
  @apply mr-4 text-motif-400;
  border: 1px solid rgba(110, 87, 236, 0.2);
}
.confirm-button {
  @apply text-white border bg-motif;
}
</style>
